import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "lk-icon",
  width: "24",
  height: "24",
  "aria-hidden": "true",
  focusable: "false"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "logout-confirm-lk-modal__title" }
const _hoisted_4 = { class: "logout-confirm-lk-modal__actions" }

import { computed, nextTick, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'logout-confirm-modal',
  props: {
    logoutUrl: { default: 'login-form.html' },
    title: { default: 'Выйти из профиля?' },
    cancelLabel: { default: 'Остаться' },
    confirmLabel: { default: 'Да, выйти' }
  },
  setup(__props: any) {

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

const props = __props;

const isOpen = ref(false);
const normalizedLogoutUrl = computed(() => props.logoutUrl.trim());

const open = async () => {
  isOpen.value = true;
  await nextTick();
  // ЛК шире экрана — модалка центрируется по странице; подскролливаем к ней
  requestAnimationFrame(() => {
    document.querySelector('.logout-confirm-lk-modal')?.scrollIntoView({
      block: 'center',
      inline: 'center',
    });
  });
};

const close = () => {
  isOpen.value = false;
};

const confirmLogout = () => {
  window.location.href = normalizedLogoutUrl.value;
};

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: "residency-lk-sidebar__logout",
      "aria-label": "Выйти из профиля",
      onClick: open
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_1, [
        _createElementVNode("use", {
          href: `${_unref(ICONS_BASE)}/residency-lk-sprite.svg#lk-icon-logout`
        }, null, 8, _hoisted_2)
      ])),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "residency-lk-sidebar__logout-text" }, "Выйти", -1))
    ]),
    _createVNode(_component_a_modal, {
      open: isOpen.value,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
      centered: "",
      width: 400,
      class: "logout-confirm-lk-modal",
      footer: null,
      closable: false,
      "mask-closable": true,
      keyboard: true,
      onCancel: close
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(props.title), 1),
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "logout-confirm-lk-modal__divider",
          "aria-hidden": "true"
        }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary btn-medium",
            onClick: close
          }, _toDisplayString(props.cancelLabel), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-medium",
            "data-barba-prevent": "",
            onClick: confirmLogout
          }, _toDisplayString(props.confirmLabel), 1)
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})